/* eslint-disable @typescript-eslint/camelcase */
module.exports = {
  siteMetadata: {
    title:
      'Ada Aesthetics - Expert Lip Fillers & Anti-Wrinkle Treatments in Cheshunt',
    description:
      'Professional aesthetic treatments in Cheshunt, Hertfordshire. Specializing in lip fillers, Russian lips, anti-wrinkle injections, and dermal fillers. Natural-looking results by certified practitioners. Call 07478705252 to book your consultation.',
    siteUrl: 'https://adaaesthetics.uk/',
    author: 'Ada Aesthetics',
    keywords:
      'lip fillers Cheshunt, anti-wrinkle injections, dermal fillers, Russian lips, aesthetic treatments Hertfordshire',
    telephone: '07478705252',
    address: '15 Ousden Drive, Cheshunt, EN8 9RL',
  },
  pathPrefix: '/',
  plugins: [
    `gatsby-plugin-react-helmet`,
    {
      resolve: 'gatsby-source-filesystem',
      options: {
        path: `${__dirname}/static/images/`,
        name: 'images',
      },
    },
    {
      resolve: 'gatsby-transformer-remark',
      options: {
        plugins: [
          // Custom responsive images plugin (replaces gatsby-remark-images)
          // Works without Sharp dependency for ARM64 compatibility
          {
            resolve: require.resolve(
              './plugins/gatsby-remark-responsive-images'
            ),
            options: {
              maxWidth: 750,
              quality: 85,
              withWebp: true,
              loading: 'lazy',
              linkImagesToOriginal: false,
              wrapperStyle: 'margin-bottom: 1.0725rem;',
            },
          },
          {
            resolve: 'gatsby-remark-responsive-iframe',
            options: {
              wrapperStyle: 'margin-bottom: 1.0725rem',
            },
          },
          'gatsby-remark-prismjs',
          'gatsby-remark-copy-linked-files',
          'gatsby-remark-smartypants',
        ],
      },
    },
    // Temporarily disabled due to Sharp dependency issues
    // gatsby-plugin-manifest requires Sharp for icon processing
    // {
    //   resolve: `gatsby-plugin-manifest`,
    //   options: {
    //     name: 'Ada Aesthetics',
    //     short_name: 'Ada Aesthetics',
    //     description:
    //       'Professional aesthetic treatments in Cheshunt, Hertfordshire. Specializing in lip fillers, Russian lips, anti-wrinkle injections, and dermal fillers.',
    //     homepage_url: 'https://adaaesthetics.uk/',
    //     start_url: '/',
    //     background_color: '#fff',
    //     theme_color: '#e91e63',
    //     display: 'standalone',
    //     icons: [
    //       {
    //         src: '/images/android-chrome-192x192.png',
    //         sizes: '192x192',
    //         type: 'image/png',
    //       },
    //       {
    //         src: '/images/android-chrome-512x512.png',
    //         sizes: '512x512',
    //         type: 'image/png',
    //       },
    //     ],
    //   },
    // },
    {
      resolve: 'gatsby-plugin-netlify',
      options: {
        mergeSecurityHeaders: true,
        mergeLinkHeaders: true,
        mergeCachingHeaders: true,
      },
    },
    {
      resolve: 'gatsby-plugin-graphql-codegen',
      options: {
        fileName: `types/graphql-types.d.ts`,
      },
    },
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        // You can add multiple tracking ids and a pageview event will be fired for all of them.
        trackingIds: [
          'UA-179550909-1', // Google Analytics / GA
        ],
      },
    },
    {
      resolve: `gatsby-plugin-gdpr-cookies`,
      options: {
        googleAnalytics: {
          trackingId: 'G-L6BVFCMKQ0',
          anonymize: true,
        },
        environments: ['production', 'development'],
      },
    },
    'gatsby-plugin-catch-links',
    'gatsby-plugin-offline',
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-sass',
    // 'gatsby-plugin-sharp', // Temporarily disabled due to Sharp dependency issues
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        output: `/sitemap.xml`,
        excludes: [`/404/`, `/404.html`],
        query: `
          {
            site {
              siteMetadata {
                siteUrl
              }
            }
            allSitePage {
              nodes {
                path
              }
            }
          }
        `,
        serialize: ({ site, allSitePage }) =>
          allSitePage.nodes.map((node) => {
            return {
              url: `${site.siteMetadata.siteUrl}${node.path}`,
              changefreq: `weekly`,
              priority: node.path === '/' ? 1.0 : 0.8,
              lastmod: new Date().toISOString().split('T')[0],
            }
          }),
      },
    },
    'gatsby-plugin-typescript',
    // 'gatsby-transformer-sharp', // Temporarily disabled due to Sharp dependency issues
  ],
}
